import styled from 'styled-components'

export const Background = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.border};
  border: none;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
`

export const Button = styled.button`
  padding: 0;
  background: none;
  border: none;
  width: 3.4rem;
  height: 3.4rem;

  ${Background} {
    &:active {
      border: 1px solid ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`
